import { useState } from "react";
import { InfoIcon } from "@phosphor-icons/react";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { Tooltip, TooltipContent, TooltipTrigger } from "@libs/zapi-ui/shadcn";
import { useProjectStore } from "@/zapi-frontend/stores/project";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";
import { useMediaQuery } from "@/zapi-frontend/shared/hooks/useMediaQuery";

export function ProjectInfoTooltip() {
  const { selectedProject } = useProjectStore();
  const { activeChapter, viewMode } = useChapterStore();
  const { isLabs, organizationName } = useMeStore();
  const { isSystemAdmin, availableOrganizations } = useOrganizationStore();
  const isTouchDevice = useMediaQuery("(hover: none) and (pointer: coarse)");
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const projectOrgName = isSystemAdmin
    ? availableOrganizations.find((org) => org.id === selectedProject?.organizationId)?.name
    : organizationName;
  const prereqsNames = (activeChapter?.projectTemplateChapter.prereqs || []).map(
    (slug) =>
      selectedProject?.projectChapters?.find((i) => i.projectTemplateChapter.slug === slug)?.projectTemplateChapter
        .name || slug
  );

  return (
    <Tooltip open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
      <TooltipTrigger
        asChild
        onTouchStart={(e) => {
          if (isTouchDevice) {
            e.preventDefault();
            setIsTooltipOpen((prev) => !prev);
          }
        }}
      >
        <button
          data-testid="project-header-info-trigger"
          type="button"
          className="cursor-pointer select-none touch-manipulation"
        >
          <InfoIcon className="size-4 text-innoveraZinc-500" />
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <div className="flex flex-col gap-1 max-w-[400px]">
          {selectedProject?.projectTemplateName && (
            <FigmaTypography variant="body-2" className="w-full">
              Analysis Type: <strong>{selectedProject.projectTemplateName}</strong>
            </FigmaTypography>
          )}
          {isLabs && selectedProject?.projectTemplateSlug && (
            <>
              {" "}
              <FigmaTypography variant="body-2" className="w-full">
                Template id: <strong>{selectedProject.projectTemplateSlug}</strong>
              </FigmaTypography>{" "}
              {viewMode !== "dashboard" && viewMode !== "projectOverview" && activeChapter && (
                <FigmaTypography variant="body-2" className="w-full">
                  Chapter id: <strong>{activeChapter?.id}</strong>
                </FigmaTypography>
              )}
              <FigmaTypography variant="body-2" className="w-full">
                Organization name: <strong>{projectOrgName}</strong>
              </FigmaTypography>
              {viewMode !== "dashboard" && viewMode !== "projectOverview" && prereqsNames.length > 0 && (
                <FigmaTypography variant="body-2" className="w-full">
                  Prereqs: <strong>{prereqsNames.join(", ")}</strong>
                </FigmaTypography>
              )}
            </>
          )}
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
